import { render, staticRenderFns } from "./createTemplateForm.vue?vue&type=template&id=030f65e5&"
import script from "./createTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./createTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./createTemplateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports